module.exports = __webpack_public_path__ + "logo-origami-colored.png?a1b5818baaebda44750730b65ed1ea1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-origami-colored.png
// module id = 87
// module chunks = 0